import { defaultLocale, getCurrentLanguage } from '@framework/i18n';
import { AxiosHeaders, AxiosInstance, InternalAxiosRequestConfig } from 'axios';

/**
 * Aggiunge alle richieste la lingua impostata nel client
 */
export function languageInterceptor(apiClient: AxiosInstance) {
  apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    if (!config.headers) config.headers = new AxiosHeaders();

    // Estrapolo il locale della lingua corrente senza prendere quello direttamente
    // fornito da i18n perche' le API richiedono un formato specifico (es. 'it-IT').
    // Su backend (dove non c'è supporto all'`intl`) usiamo sempre la key di default.
    const languageTag = config.meta?.hasIntlSupport
      ? defaultLocale.tag
      : getCurrentLanguage().tag;

    // Non sostituisco l'header se già precedentemente fornito
    config.headers['Accept-Language'] =
      config.headers['Accept-Language'] ?? languageTag;

    return config;
  });
}
